import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const unHaulApprovalStatusesAdapter = getAdapter({ idFieldName: 'value' });

const unHaulApprovalStatusesSlice = createSlice({
  name: 'unHaulApprovalStatuses',
  initialState: unHaulApprovalStatusesAdapter.getInitialState(),
  reducers: {
    setUnHaulApprovalStatuses: (state, { payload: { unHaulApprovalStatuses } }) => {
      unHaulApprovalStatusesAdapter.setAll(state, unHaulApprovalStatuses);
    },
  },
});

const selectors = unHaulApprovalStatusesAdapter.getSelectors(({ unHaulApprovalStatuses }) => unHaulApprovalStatuses);

export const getUnHaulApprovalStatuses = (state) => selectors.selectAll(state);

export const {
  setUnHaulApprovalStatuses,
} = unHaulApprovalStatusesSlice.actions;

export default unHaulApprovalStatusesSlice.reducer;
